import type React from 'react'

import { JudicialVolunteerSearchFormBody } from './JudicialVolunteerSearchFormBody'
import {
  JudicialVolunteerSearchFormProvider,
  type JudicialVolunteerSearchFormProviderProps,
} from './JudicialVolunteerSearchFormProvider'

export type JudicialVolunteerSearchFormProps = JudicialVolunteerSearchFormProviderProps

export const JudicialVolunteerSearchForm: React.FC<JudicialVolunteerSearchFormProps> = ({ ...props }) => (
  <JudicialVolunteerSearchFormProvider {...props} className="flex-1">
    <JudicialVolunteerSearchFormBody />
  </JudicialVolunteerSearchFormProvider>
)
